export const CACHE_KEYS = {
  NOTES: 'notes' as const,
  NOTES_TAGS: 'notes-tags' as const,
  CAREER_CARDS: 'career-cards' as const,
  CAREER_CARDS_BASIC: 'career-cards-basic' as const,
  CAREER_CARD_SCHEMAS: 'career-card-schemas' as const,
  CAREER_CARD_HISTORY: 'career-card-history' as const,
  CAREER_CARD_TEMPLATES: 'career-card-templates' as const,
  WORK_EXPERIENCES: 'work-experiences' as const,
  RETROSPECTIVES: 'retrospectives' as const,
  RETROSPECTIVE_ENTRIES: 'retrospective-entries' as const,
  TIMELINE: 'timeline' as const,
  RESUMES: 'resumes' as const,
  JOB_SEARCH: 'job-search' as const,
  REVIEWS: 'reviews' as const,
  CONTENT_LINKS: 'content_links',
  CAREER_FOCUS: 'career-focus' as const,
  CAREER_FOCUS_ACTIVE: 'career-focus-active' as const,
  ALL_ACTIVE_FOCUSES: 'all-active-focuses' as const,
  COMPLETED_FOCUSES: 'completed-focuses' as const,
  GOAL_EVIDENCE: 'goal-evidence' as const,
  GOAL_CARDS: 'goal-cards' as const,
  RUBRIC: 'rubric' as const,
  RUBRIC_TEMPLATES: 'rubric-templates' as const,
  INTERNSHIP_RUBRIC: 'internship-rubric' as const,
  ASSESSMENTS: 'assessments' as const,
  FOCUS_GOALS: 'focus-goals' as const,
} as const;

export const CACHE_DURATIONS = {
  SHORT: 5 * 60 * 1000, // 5 minutes
  MEDIUM: 15 * 60 * 1000, // 15 minutes
  LONG: 60 * 60 * 1000, // 1 hour
  FOCUS_GOALS: 10 * 60 * 1000, // 10 minutes
  RUBRIC_TEMPLATES: 30 * 60 * 1000, // 30 minutes
  INTERNSHIP_RUBRIC: 15 * 60 * 1000, // 15 minutes
  CAREER_FOCUS: 15 * 60 * 1000, // 15 minutes
} as const; 